import { configure } from 'axios-hooks'
import Cookies from 'universal-cookie'
import NotificationService from '../base/notifications.service'
import createHttpClient from './createHttpClient'


/**
 * =========================================
 * ERROR PARSER
 * =========================================
 */
const parseErrors = (error) => {
    const serverError = 'Server error!'
    let errorMessage = ''

    if (error?.response?.status >= 500) {
        return serverError
    }

    if (error?.response?.data?.message) {
        errorMessage = error.response.data.message
    }

    if (error?.response?.data?.errors) {
        const errors = error.response.data.errors

        if (typeof errors === 'string') {
            errorMessage += ' ' + errors
        } else {
            const keys = Object.keys(errors)
            if (keys.length > 0) {
                errorMessage += ' ' + errors[keys[0]]
            }
        }
    }

    if (!errorMessage && error?.message) {
        errorMessage = error.message
    }

    return errorMessage || serverError
}

/**
 * =========================================
 * SESSION HELPERS
 * =========================================
 */
const getSession = () => {
    const cookies = new Cookies()
    const user = cookies.get('user', { path: '/' })
    return user ?? false
}

const getUserData = () => {
    const cookies = new Cookies()
    const user = cookies.get('user', { path: '/' })
    return Promise.resolve(user?.id ? user : null)
}

/**
 * =========================================
 * CLIENTS
 * =========================================
 */

const marketplaceClient = createHttpClient('/marketplace/api/')
const notificationsClient = createHttpClient('/api/notifications')

// axios-hooks конфигурируем на marketplace по умолчанию
configure({ axios: marketplaceClient })

/**
 * =========================================
 * ERROR HANDLER
 * =========================================
 */
const handleError = (error, showNotification = true) => {
    if (showNotification && error?.response?.status !== 401) {
        const notification = new NotificationService()
        notification.error(
            `Error ${error?.response?.status || 500}`,
            parseErrors(error)
        )
    }
    throw error
}

/**
 * =========================================
 * MAIN SERVICE (СО СТАРЫМ API)
 * =========================================
 */

const ApiService = {

    // ===== SESSION =====
    getUserData: () => getUserData(),

    checkSession: () => !!getSession(),

    // ===== MARKETPLACE (старое поведение по умолчанию) =====
    getData: (url, config = {}, noCatch = false) => {
        if (noCatch) return marketplaceClient.get(url, config)
        return marketplaceClient.get(url, config)
            .catch((error) => handleError(error, true))
    },

    postData: (url, data = {}, noCatch = false) => {
        if (url === 'auth') {
            return marketplaceClient.post(url, data)
        }

        if (noCatch) return marketplaceClient.post(url, data)

        return marketplaceClient.post(url, data)
            .catch((error) => handleError(error, true))
    },

    putData: (url, data = {}, noCatch = false) => {
        if (noCatch) return marketplaceClient.put(url, data)

        return marketplaceClient.put(url, data)
            .catch((error) => handleError(error, true))
    },

    patch: (url, data = {}, noCatch = false) => {
        if (noCatch) return marketplaceClient.patch(url, data)

        return marketplaceClient.patch(url, data)
            .catch((error) => handleError(error, true))
    },

    delete: (url, data = {}, noCatch = false) => {
        if (noCatch) return marketplaceClient.delete(url, { data })

        return marketplaceClient.delete(url, { data })
            .catch((error) => handleError(error, true))
    },

    getImage: (url) => {
        return marketplaceClient.get(url, {
            responseType: 'arraybuffer'
        })
    },

    // ===== NOTIFICATIONS (доступ при необходимости) =====
    notifications: {
        getData: (url, config = {}) =>
            notificationsClient.get(url, config),

        postData: (url, data = {}) =>
            notificationsClient.post(url, data),

        putData: (url, data = {}) =>
            notificationsClient.put(url, data),

        patch: (url, data = {}) =>
            notificationsClient.patch(url, data),

        delete: (url, data = {}) =>
            notificationsClient.delete(url, { data })
    },

    // ===== ERRORS =====
    parseErrors
}

export default ApiService